<template>
  <div>
    <agree-item
      :item="item"
      v-for="(item, index) in agreeItems"
      v-if="item.isEnable == 1"
      :key="index"
      @agreeCheckEvent="agreeCheckHandler"
      @agreeOpenEvent="agreeOpenEventHandler"
    />

    <p v-if="loadError" class="text-danger mt-20">약관을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.</p>

    <!-- 서약 회사명 (대표이사/서명/날짜 대체) -->
    <div class="mt-20">
      <label class="form-control-label"><span class="ess">회사명</span></label>
      <input type="text" class="form-control" v-model="companyName"
             placeholder="서약 주체 회사명을 입력하세요" style="max-width:360px;">
    </div>

    <div class="mt-20">
      <small>
        <label class="md-check">
          <input type="checkbox" v-model="isCheckAll" @change="checkAllHandler">
          <i class="blue"></i>모든 약관에 동의합니다.
        </label>
      </small>
    </div>
    <div class="btn-wrap mt-30 justify-content-center">
      <button class="btn btn-lg line-2" @click="prev()">
        <i class="icon-arrow-line-left mr-5"></i>이전
      </button>
      <button class="btn btn-lg blue" @click="next()" :disabled="cannotNext">
        다음<i class="icon-arrow-line-right ml-5"></i>
      </button>
    </div>
  </div>
</template>

<script>
import AgreeItem from '@/views/app/main/AgreeItem.vue';

export default {
  components: {
    AgreeItem
  },
  data() {
    return {
      agreeItems: [],
      checkedAll: false,
      companyName: '',
      loadError: false
    };
  },
  computed: {
    allChecked() {
      return this.agreeItems.length > 0
        && this.agreeItems.every((item) => item.isChecked);
    },
    cannotNext() {
      return !this.allChecked || !this.companyName || !this.companyName.trim();
    },
    isCheckAll() {
      return this.allChecked;
    }
  },
  mounted() {
    this.loadItems();
    // 이전에 입력한 회사명 복원 (뒤로 갔다 온 경우)
    try {
      const saved = JSON.parse(sessionStorage.getItem('workPermitConsent') || 'null');
      if (saved && saved.companyName) this.companyName = saved.companyName;
    } catch (e) { /* noop */ }
  },
  methods: {
    prev() {
      this.$router.back();
    },
    next() {
      if (this.cannotNext) return;
      const pledge = this.agreeItems.find((i) => i.termsType === 'PLEDGE');
      const privacy = this.agreeItems.find((i) => i.termsType === 'PRIVACY');
      const consent = {
        companyName: this.companyName.trim(),
        pledgeAgreed: !!(pledge && pledge.isChecked),
        pledgeTermsId: pledge ? pledge.termsId : null,
        pledgeVersion: pledge ? pledge.version : null,
        privacyAgreed: !!(privacy && privacy.isChecked),
        privacyTermsId: privacy ? privacy.termsId : null,
        privacyVersion: privacy ? privacy.version : null,
        agreedAt: Date.now()
      };
      sessionStorage.setItem('workPermitConsent', JSON.stringify(consent));
      this.$router.push({ path: '/app/workPermit/input' });
    },
    /** 활성 약관(서약서/개인정보)을 서버에서 조회해 동의 항목으로 구성. */
    async loadItems() {
      this.loadError = false;
      try {
        const res = await this.$http.get('/api/public/work-permit/terms/active');
        const list = (res && res.data ? (res.data.payload || res.data) : []) || [];
        // PLEDGE 를 먼저 노출
        const order = { PLEDGE: 0, PRIVACY: 1 };
        list.sort((a, b) => (order[a.termsType] ?? 99) - (order[b.termsType] ?? 99));
        this.agreeItems = list.map((t, idx) => ({
          tosIndex: idx + 1,
          termsId: t.termsId,
          termsType: t.termsType,
          version: t.version,
          tosTitle: t.title,
          tosAgreeText: t.agreeText,
          tosContents: t.content,
          isEnable: 1,
          isChecked: false,
          isOpen: false
        }));
        this.loadError = this.agreeItems.length === 0;
      } catch (e) {
        console.log('약관 조회 실패', e);
        this.agreeItems = [];
        this.loadError = true;
      }
    },
    checkAllHandler() {
      const target = !this.allChecked;
      this.agreeItems.forEach((item) => {
        item.isChecked = target;
      });
    },
    agreeCheckHandler(data) {
      this.agreeItems.forEach((item) => {
        if (data.tosIndex === item.tosIndex) {
          item.isChecked = data.isChecked;
          item.isOpen = data.isChecked;
        }
      });
    },
    agreeOpenEventHandler(data) {
      this.agreeItems.forEach((item) => {
        if (data.tosIndex === item.tosIndex) {
          item.isOpen = !data.isOpen;
        }
      });
    }
  }
};
</script>
